import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Address } from 'viem'
import { useEWithdrawCollateralDialog } from './logic/useEWithdrawCollateralDialog'
import { EWithdrawCollateralView } from './views/EWithdrawCollateralView'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { withSuspense } from '@/ui/utils/withSuspense'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'

interface EWithdrawCollateralDialogContentContainerProps {
  closeDialog: () => void
  collateralVault: Address
  collateralAsset: Address
  collateralSymbol: string
  collateralDecimals: number
  collateralLogoURI?: string
  collateralPriceUSD: number
  currentCollateralFormatted: number
  currentDebtUSD: number
  currentLTV: number
  maxLTV: number
  liquidationLTV: number
  accountTotalCollateralUSD?: number
  subAccountId?: number
}

function EWithdrawCollateralDialogContentContainerInternal({
  closeDialog,
  collateralVault,
  collateralAsset,
  collateralSymbol,
  collateralDecimals,
  collateralLogoURI,
  collateralPriceUSD,
  currentCollateralFormatted,
  currentDebtUSD,
  currentLTV,
  maxLTV,
  liquidationLTV,
  accountTotalCollateralUSD,
  subAccountId,
}: EWithdrawCollateralDialogContentContainerProps) {
  const {
    collateralToken,
    withdrawAmount,
    setWithdrawAmount,
    maxWithdrawable,
    newLTV,
    unwrapToNative,
    setUnwrapToNative,
    isWhypeCollateral,
    wouldLiquidate,
    withdrawStatus,
    handleExecute,
    isSimulating,
    isSuccess,
    displayError,
    isTimedOut,
  } = useEWithdrawCollateralDialog({
    collateralVault,
    collateralAsset,
    collateralSymbol,
    collateralDecimals,
    collateralLogoURI,
    collateralPriceUSD,
    currentCollateralFormatted,
    currentDebtUSD,
    currentLTV,
    maxLTV,
    liquidationLTV,
    accountTotalCollateralUSD,
    subAccountId,
  })

  if (isSuccess) {
    return (
      <SuccessView
        objectiveType="withdraw"
        tokenWithValue={{
          token: collateralToken,
          value: NormalizedUnitNumber(withdrawAmount),
        }}
        onProceed={closeDialog}
        proceedText="Back to Position"
      />
    )
  }

  return (
    <EWithdrawCollateralView
      collateralSymbol={collateralSymbol}
      collateralLogoURI={collateralLogoURI}
      collateralDecimals={collateralDecimals}
      withdrawAmount={withdrawAmount}
      setWithdrawAmount={setWithdrawAmount}
      currentCollateralFormatted={currentCollateralFormatted}
      maxWithdrawable={maxWithdrawable}
      currentLTV={currentLTV}
      newLTV={newLTV}
      maxLTV={maxLTV}
      liquidationLTV={liquidationLTV}
      unwrapToNative={unwrapToNative}
      setUnwrapToNative={setUnwrapToNative}
      isWhypeCollateral={isWhypeCollateral}
      collateralPriceUSD={collateralPriceUSD}
      wouldLiquidate={wouldLiquidate}
      withdrawStatus={withdrawStatus}
      handleExecute={handleExecute}
      isSimulating={isSimulating}
      displayError={displayError}
      isTimedOut={isTimedOut}
    />
  )
}

export const EWithdrawCollateralDialogContentContainer = withSuspense(
  EWithdrawCollateralDialogContentContainerInternal,
  DialogContentSkeleton,
)
